module.exports = __webpack_public_path__ + "img/frown.a86be16c.svg";